/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'ssrUTWckL5EvE7hDACE5FF.png': { uri: '/images/ssrUTWckL5EvE7hDACE5FF.png' },
'oNzgDbJ5qCrG9eEy2chXbo.png': { uri: '/images/oNzgDbJ5qCrG9eEy2chXbo.png' },
'qYx849Y4e3pQ3PwUMLpcUM.png': { uri: '/images/qYx849Y4e3pQ3PwUMLpcUM.png' },
'msWzsTrxwqMDiMStyNcL2m.png': { uri: '/images/msWzsTrxwqMDiMStyNcL2m.png' },
'd54o8rCrwgQrRYMAdeUqQP.png': { uri: '/images/d54o8rCrwgQrRYMAdeUqQP.png' },
'wW8ZKnHTqCAZ2qxh5LhWjR.png': { uri: '/images/wW8ZKnHTqCAZ2qxh5LhWjR.png' },
'mMzvmtsJd8FxSgq9WgjJRG.png': { uri: '/images/mMzvmtsJd8FxSgq9WgjJRG.png' },
'9B5HBtK94YTYf3ws6bs3bA.png': { uri: '/images/9B5HBtK94YTYf3ws6bs3bA.png' },
'irtSqpjXH8BrLH1bBx3WMt.png': { uri: '/images/irtSqpjXH8BrLH1bBx3WMt.png' },
'gK1aa4UymBcVahF3D13mMB.png': { uri: '/images/gK1aa4UymBcVahF3D13mMB.png' },
'qH2ZnTodWwKWbFtS3A9mBT.png': { uri: '/images/qH2ZnTodWwKWbFtS3A9mBT.png' },
'iYzScR7vMU23GNtFn8q49S.jpg': { uri: '/images/iYzScR7vMU23GNtFn8q49S.jpg' },
'4EKazJRfx3kPbqtFYex2xp.jpg': { uri: '/images/4EKazJRfx3kPbqtFYex2xp.jpg' },
'5MDPGKDSGvfA8kKwNSRkzd.jpg': { uri: '/images/5MDPGKDSGvfA8kKwNSRkzd.jpg' },
'emks4QZZuAe5HnmB83St2M.jpg': { uri: '/images/emks4QZZuAe5HnmB83St2M.jpg' },
'rPw7P8CtgAJqTzZ3XqedF6.jpg': { uri: '/images/rPw7P8CtgAJqTzZ3XqedF6.jpg' }
}

export default imageStaticSourcesByFileName
